<template>
  <div class="flex flex-row h-full pb-12 overflow-hidden">
    <div
      class="overflow-hidden h-full shrink-0"
      v-if="Identity.IsAuthenticated"
    >
      <Navigation />
    </div>
    <div class="grow overflow-hidden h-full">
      <router-view v-slot="{ Component }">
        <suspense timeout="0">
          <component :is="Component" />
          <template #fallback><Loader /></template>
        </suspense>
      </router-view>
    </div>
    
  </div>
  <Footer />
</template>

<script setup lang="ts">
import Navigation from "./components/Navigation.vue";
import Footer from "./components/Footer.vue";
import { useIdentity } from "./features/identity";

const { Identity } = useIdentity();

</script>
